import React from 'react';

export function columnsPayable(t) {
  return [{ title: t('general.code'), field: 'id' }];
}

export function columnsReceivable(t) {
  return [
    { title: t('general.code'), field: 'id' },
    {
      title: t('general.description'),
      field: 'description',
      cellRenderer: (data) => {
        const { rowData } = data;
        return (
          <span
            className="BaseTable__row-cell-text tooltip-test"
            title={rowData.description}
          >
            {rowData.description}
          </span>
        );
      },
    },
    {
      title: t('general.contract'),
      field: 'contract',
      cellRenderer: (data) => {
        const { rowData } = data;
        return (
          <span
            className="BaseTable__row-cell-text tooltip-test"
            title={rowData.contract}
          >
            {rowData.contract}
          </span>
        );
      },
    },
    {
      title: t('general.due-date'),
      field: 'formattedDueDate',
    },
    {
      title: t('general.settled-date'),
      field: 'formattedPaymentDate',
    },
    {
      title: t('general.value'),
      field: 'formattedValue',
    },
    {
      title: t('general.amount-received'),
      field: 'formattedAmountReceived',
    },
    {
      title: t('general.discount'),
      field: 'formattedDiscount',
    },
    {
      title: t('general.student'),
      field: 'student.fullName',
      cellRenderer: (data) => {
        const { rowData } = data;
        return (
          <span
            className="BaseTable__row-cell-text tooltip-test"
            title={rowData.student.fullName}
          >
            {rowData.student.fullName}
          </span>
        );
      },
    },
    {
      title: t('general.responsible-account'),
      field: 'responsible.fullName',
      cellRenderer: (data) => {
        const { rowData } = data;
        return (
          <span
            className="BaseTable__row-cell-text tooltip-test"
            title={rowData.responsible.fullName}
          >
            {rowData.responsible.fullName}
          </span>
        );
      },
    },
    {
      title: t('general.cpf'),
      field: 'cpf',
      minWidth: 110,
    },
    {
      title: t('general.category'),
      field: 'category.name',
      cellRenderer: (data) => {
        const { rowData } = data;
        return (
          <span
            className="BaseTable__row-cell-text tooltip-test"
            title={rowData.category.name}
          >
            {rowData.category.name}
          </span>
        );
      },
    },
    { title: t('general.quota'), field: 'quota' },
    {
      title: t('general.status'),
      field: 'statusDescription',
    },
    {
      title: t('general.account'),
      field: 'account.name',
    },
  ];
}
